import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, FormSection } from 'redux-form';

import InputField from '../../../shared/form-elements/input';
import ModalBox from '../../../shared/modal';

const formPropTypes = {
	intl: PropTypes.func,
	handleSubmit: PropTypes.func,
	formSubmit: PropTypes.func,
	toggleRequestModal: PropTypes.func,
	isAdvFormEditMode: PropTypes.bool,
	modalData: PropTypes.object,
	markAsRead: PropTypes.func,
	advRequestOpenedId: PropTypes.number
};

const mainPropTypes = {
	intl: PropTypes.func,
	shouldShowAdvRequestForm: PropTypes.bool,
	toggleRequestModal: PropTypes.func
};

const Form = props => (
	<div className="adv-request__wrap">
		<form action="" className="ui-form" onSubmit={
			e => {
				e.preventDefault();
				props.modalData && !props.modalData.meta.admin_viewed ?
					props.markAsRead(props.advRequestOpenedId) :
					props.toggleRequestModal();
			}}>
			<div className="ui-form__element">
				<FormSection className="request-data" name='requestData'>
					<p className="section-title data">{props.intl('Personal data')}</p>
					<div className="input-group">
						<div className="input-wrap">
							<Field
								name='name'
								component={InputField}
								placeholder={props.intl('Name')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
						<div className="input-wrap">
							<Field
								name='company'
								component={InputField}
								placeholder={props.intl('Company')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
						<div className="input-wrap">
							<Field
								name='email'
								component={InputField}
								placeholder={props.intl('Email')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
						<div className="input-wrap">
							<Field
								name='website'
								component={InputField}
								placeholder={props.intl('Website (landing)')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
						<div className="input-wrap">
							<Field
								name='product'
								component={InputField}
								placeholder={props.intl('Product (service)')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
						<div className="input-wrap">
							<Field
								name='phone'
								component={InputField}
								placeholder={props.intl('Phone')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
						<div className="input-wrap">
							<Field
								name='created_at'
								component={InputField}
								placeholder={props.intl('Created at')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
						<div className="input-wrap">
							<Field
								name='goal_type'
								component={InputField}
								placeholder={props.intl('Target action')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
						<div className="input-wrap">
							<Field
								name='skype'
								component={InputField}
								placeholder={props.intl('Skype')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
					</div>
				</FormSection>
				<FormSection className="action-data" name='actionData'>
					<p className="section-title actions">{props.intl('Actions')}</p>
					<div className="input-group">
						<div className="input-wrap">
							<Field
								name='payout'
								component={InputField}
								placeholder={props.intl('Expected payout')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
						<div className="input-wrap">
							<Field
								name='audience'
								component={InputField}
								placeholder={props.intl('Audience')}
								required={false}
								disabled={!props.isAdvFormEditMode}
							/>
						</div>
					</div>
				</FormSection>
			</div>
			<div className="ui-form__element buttons-wrap">
				<button className="ui-btn ui-btn-primary">{props.intl('Ok')}</button>
			</div>
		</form>
	</div>
);

const Main = props => (
	<ModalBox
		title={props.intl('Advertisers request details')}
		body={Form(props)}
		isOpen={props.shouldShowAdvRequestForm}
		onClose={props.toggleRequestModal}
		className="adv-request-modal"
	/>
);

Form.propTypes = formPropTypes;
Main.propTypes = mainPropTypes;

export default formName =>
	reduxForm({
		form: formName
	})(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/advertisers-requests/components/adv-requests-form/main.js